module.exports = __webpack_public_path__ + "static/img/7.a6a4b4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/7.png
// module id = rEir
// module chunks = 0